export default __webpack_public_path__ + "static/media/inActiveTable.6fe1ce65.svg";